<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card>
          <template #header>
            <h5 class="m-0">Configurar Prova</h5>
          </template>

          <b-card-body>
            <b-tabs v-model="currentTab" pills card>
              <!-- Tab Informações -->
              <b-tab title="Informações" active>
                <b-form @submit.prevent="saveExam">
                  <b-form-group label="Título *">
                    <b-form-input
                      v-model="exam.title"
                      required
                      placeholder="Ex: Prova Final Compliance"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Descrição">
                    <b-form-textarea
                      v-model="exam.description"
                      rows="4"
                      placeholder="Descrição da prova"
                    ></b-form-textarea>
                  </b-form-group>

                  <b-row>
                    <b-col md="4">
                      <b-form-group label="Nota Mínima para Aprovação (%)">
                        <b-form-input
                          v-model.number="exam.passingScore"
                          type="number"
                          min="0"
                          max="100"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="Tempo Limite (minutos)">
                        <b-form-input
                          v-model.number="timeLimitMinutes"
                          type="number"
                          min="1"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="Máximo de Tentativas">
                        <b-form-input
                          v-model.number="exam.maxAttempts"
                          type="number"
                          min="1"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group>
                    <b-form-checkbox v-model="exam.shuffleQuestions" switch
                      >Embaralhar perguntas</b-form-checkbox
                    >
                  </b-form-group>

                  <b-form-group>
                    <b-form-checkbox v-model="exam.shuffleAnswers" switch
                      >Embaralhar respostas</b-form-checkbox
                    >
                  </b-form-group>

                  <div class="mt-3">
                    <b-button type="submit" variant="primary" class="mr-2">
                      <i class="fa fa-save mr-1"></i>Salvar
                    </b-button>
                    <b-button variant="secondary" @click="goBack">
                      <i class="fa fa-arrow-left mr-1"></i>Voltar
                    </b-button>
                  </div>
                </b-form>
              </b-tab>

              <!-- Tab Perguntas -->
              <b-tab title="Perguntas">
                <div v-if="!exam._id" class="text-center py-5">
                  <p>Salve a prova primeiro para adicionar perguntas</p>
                </div>
                <div v-else>
                  <div class="mb-3">
                    <b-button
                      variant="primary"
                      size="sm"
                      @click="openQuestionModal()"
                    >
                      <i class="fa fa-plus mr-1"></i>Adicionar Pergunta
                    </b-button>
                  </div>

                  <b-table
                    :items="exam.questions"
                    :fields="questionFields"
                    thead-class="questions-header"
                    :tbody-tr-class="rowClass"
                    striped
                    hover
                    responsive
                    show-empty
                  >
                    <template #empty>
                      <div class="text-center py-5">
                        <i class="fas fa-question-circle fa-2x"></i>
                        <p class="mt-3">Nenhuma pergunta adicionada</p>
                      </div>
                    </template>
                    <template #cell(question)="data">
                      <strong>{{ data.value }}</strong>
                    </template>
                    <template #cell(type)="data">
                      <b-badge
                        :variant="
                          data.value === 'multiple-choice' ? 'primary' : 'info'
                        "
                      >
                        {{
                          data.value === "multiple-choice"
                            ? "Múltipla Escolha"
                            : "Verdadeiro/Falso"
                        }}
                      </b-badge>
                    </template>
                    <template #cell(actions)="data">
                      <b-button
                        size="sm"
                        variant="link"
                        @click="openQuestionModal(data.index)"
                        v-b-tooltip
                        title="Editar"
                      >
                        <i class="fa fa-edit action-icon"></i>
                      </b-button>
                      <b-button
                        size="sm"
                        variant="link"
                        @click="deleteQuestion(data.index)"
                        v-b-tooltip
                        title="Deletar"
                      >
                        <i class="fa fa-trash action-icon text-danger"></i>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </b-tab>
            </b-tabs>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modal Pergunta -->
    <b-modal
      v-model="questionModalVisible"
      :title="
        editingQuestionIndex !== null ? 'Editar Pergunta' : 'Nova Pergunta'
      "
      size="lg"
      @ok="saveQuestion"
    >
      <b-form>
        <b-form-group label="Pergunta *">
          <b-form-textarea
            v-model="questionForm.question"
            rows="3"
            required
          ></b-form-textarea>
        </b-form-group>

        <b-form-group label="Tipo *">
          <b-form-radio-group
            v-model="questionForm.type"
            :options="questionTypes"
            stacked
          ></b-form-radio-group>
        </b-form-group>

        <!-- Múltipla Escolha -->
        <div v-if="questionForm.type === 'multiple-choice'">
          <b-form-group label="Opções *">
            <div
              v-for="(option, idx) in questionForm.options"
              :key="idx"
              class="mb-2"
            >
              <b-input-group>
                <b-input-group-prepend
                  ><b-input-group-text>{{
                    ["A", "B", "C", "D"][idx]
                  }}</b-input-group-text></b-input-group-prepend
                >
                <b-form-input
                  v-model="questionForm.options[idx]"
                  required
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    :variant="
                      questionForm.correctAnswer === idx
                        ? 'success'
                        : 'outline-secondary'
                    "
                    @click="questionForm.correctAnswer = idx"
                  >
                    <i class="fa fa-check"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-form-group>
        </div>

        <!-- Verdadeiro/Falso -->
        <div v-if="questionForm.type === 'true-false'">
          <b-form-group label="Resposta Correta *">
            <b-form-radio-group
              v-model="questionForm.correctAnswer"
              :options="[
                { text: 'Verdadeiro', value: 0 },
                { text: 'Falso', value: 1 },
              ]"
              stacked
            ></b-form-radio-group>
          </b-form-group>
        </div>

        <b-form-group label="Explicação (opcional)">
          <b-form-textarea
            v-model="questionForm.explanation"
            rows="2"
          ></b-form-textarea>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { getExam, updateExam, createExam } from "@/api/ead";

export default {
  name: "ConfigurarProva",
  data() {
    return {
      exam: {
        title: "",
        description: "",
        passingScore: 70,
        timeLimit: 3600,
        maxAttempts: 3,
        shuffleQuestions: true,
        shuffleAnswers: true,
        questions: [],
      },
      timeLimitMinutes: 60,
      currentTab: 0,
      questionModalVisible: false,
      editingQuestionIndex: null,
      questionForm: {
        question: "",
        type: "multiple-choice",
        options: ["", "", "", ""],
        correctAnswer: 0,
        explanation: "",
      },
      questionFields: [
        { key: "question", label: "Pergunta", sortable: true },
        { key: "type", label: "Tipo", class: "text-center" },
        { key: "actions", label: "Ações", class: "text-center" },
      ],
      questionTypes: [
        { text: "Múltipla Escolha", value: "multiple-choice" },
        { text: "Verdadeiro/Falso", value: "true-false" },
      ],
    };
  },
  mounted() {
    const examId = this.$route.params.id;
    if (examId && examId !== "nova") {
      this.loadExam(examId);
    }
  },
  methods: {
    rowClass() {
      return "question-row";
    },
    async loadExam(examId) {
      try {
        const response = await getExam(examId);
        this.exam = response.data;
        this.timeLimitMinutes = Math.floor(this.exam.timeLimit / 60);
      } catch (error) {
        this.$bvToast.toast("Erro ao carregar prova", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          autoHideDelay: 10000,
          appendToast: true,
          solid: true,
        });
        this.goBack();
      }
    },
    async saveExam() {
      try {
        this.exam.timeLimit = this.timeLimitMinutes * 60;

        if (this.exam._id) {
          await updateExam(this.exam._id, this.exam);
          this.$bvToast.toast("Prova atualizada!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            autoHideDelay: 5000,
            appendToast: true,
            solid: true,
          });
        } else {
          const response = await createExam(this.exam);
          this.exam._id = response.data._id || response.data.exam._id;
          this.$bvToast.toast("Prova criada!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            autoHideDelay: 5000,
            appendToast: true,
            solid: true,
          });
        }
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar prova", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          autoHideDelay: 10000,
          appendToast: true,
          solid: true,
        });
      }
    },
    openQuestionModal(index = null) {
      if (index !== null) {
        this.editingQuestionIndex = index;
        const question = this.exam.questions[index];
        this.questionForm = {
          question: question.question,
          type: question.type,
          options:
            question.type === "multiple-choice"
              ? [...question.options]
              : ["Verdadeiro", "Falso"],
          correctAnswer: question.correctAnswer,
          explanation: question.explanation || "",
        };
      } else {
        this.editingQuestionIndex = null;
        this.questionForm = {
          question: "",
          type: "multiple-choice",
          options: ["", "", "", ""],
          correctAnswer: 0,
          explanation: "",
        };
      }
      this.questionModalVisible = true;
    },
    async saveQuestion(evt) {
      evt.preventDefault();
      const question = {
        question: this.questionForm.question,
        type: this.questionForm.type,
        options:
          this.questionForm.type === "multiple-choice"
            ? this.questionForm.options
            : ["Verdadeiro", "Falso"],
        correctAnswer: this.questionForm.correctAnswer,
        explanation: this.questionForm.explanation,
      };

      if (this.editingQuestionIndex !== null) {
        this.exam.questions[this.editingQuestionIndex] = question;
      } else {
        this.exam.questions.push(question);
      }

      try {
        await updateExam(this.exam._id, { questions: this.exam.questions });
        this.$bvToast.toast("Pergunta salva!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          autoHideDelay: 5000,
          appendToast: true,
          solid: true,
        });
        this.questionModalVisible = false;
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar pergunta", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          autoHideDelay: 10000,
          appendToast: true,
          solid: true,
        });
      }
    },
    async deleteQuestion(index) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        "Deletar esta pergunta?",
        {
          okVariant: "danger",
          okTitle: "Deletar",
        }
      );

      if (confirmed) {
        this.exam.questions.splice(index, 1);
        try {
          await updateExam(this.exam._id, { questions: this.exam.questions });
          this.$bvToast.toast("Pergunta deletada!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            autoHideDelay: 5000,
            appendToast: true,
            solid: true,
          });
        } catch (error) {
          this.$bvToast.toast("Erro ao deletar pergunta", {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            autoHideDelay: 10000,
            appendToast: true,
            solid: true,
          });
        }
      }
    },
    goBack() {
      this.$router.push("/ead/provas");
    },
  },
};
</script>

<style scoped>
::v-deep .questions-header th {
  background-color: #fff !important;
  font-weight: 600;
  color: #73818f;
  font-size: 0.75rem;
  text-transform: uppercase;
  border-top: 1px solid #c8ced3;
  border-bottom: 1px solid #c8ced3;
  padding: 0.75rem;
}

::v-deep .question-row {
  background-color: #fff;
}

::v-deep .question-row:nth-of-type(odd) {
  background-color: #f0f3f5;
}

::v-deep .question-row:hover {
  background-color: #e4e7ea !important;
}

::v-deep .question-row td {
  border-top: 1px solid #c8ced3;
  vertical-align: middle;
  padding: 0.75rem;
}

::v-deep .action-icon {
  color: #73818f;
}

::v-deep .question-row:hover .action-icon {
  color: #20a8d8;
}

::v-deep .action-icon.text-danger:hover {
  color: #f86c6b !important;
}
</style>
